import { isBanner } from '@as-react/common-types';
import { CompareActionTypes } from '../../../enums/ActionEnums';
export const initialCompareState = {
    initialized: false,
    collapsed: true,
    showError: false,
    items: [],
};
const filterRemovedCompareProducts = (items = [], removedCompareProduct) => items.filter((compareProduct) => {
    const equalColorId = compareProduct.color === removedCompareProduct.color;
    const equalProductCode = compareProduct.productCode === removedCompareProduct.productCode;
    return !(equalColorId && equalProductCode);
});
export const toggleComparedStateForItems = (items = [], compareItems) => items.map((item) => {
    if (isBanner(item)) {
        return item;
    }
    // @ts-expect-error - colours exist on ListerItem but are not typed correctly
    const compareItem = compareItems.find(cItem => cItem.productCode === item.productCode);
    return Object.assign(Object.assign({}, item), { 
        // @ts-expect-error - colours exist on ListerItem but are not typed correctly
        colours: item.colours.map((productColor) => (Object.assign(Object.assign({}, productColor), { isCompareProduct: !!compareItem &&
                !!compareItems.find(
                // @ts-expect-error - colours exist on ListerItem but are not typed correctly
                cItem => cItem.productCode === item.productCode && cItem.colorId === productColor.colourId) }))) });
});
export const compareReducer = (state = initialCompareState, action) => {
    switch (action.type) {
        case CompareActionTypes.COMPARE_INIT:
            return Object.assign(Object.assign({}, state), { initialized: true, items: [...action.payload] });
        case CompareActionTypes.COMPARE_ADD:
            return Object.assign(Object.assign({}, state), { items: [...state.items, action.payload.product] });
        case CompareActionTypes.COMPARE_TOGGLE_LIMIT_REACHED:
            return Object.assign(Object.assign({}, state), { showError: action.payload });
        case CompareActionTypes.COMPARE_REMOVE:
            return Object.assign(Object.assign({}, state), { items: filterRemovedCompareProducts(state.items, action.payload.product) });
        case CompareActionTypes.COMPARE_POPUP_CLOSE:
            return Object.assign(Object.assign({}, state), { collapsed: true });
        case CompareActionTypes.COMPARE_POPUP_OPEN:
            return Object.assign(Object.assign({}, state), { collapsed: false });
        case CompareActionTypes.COMPARE_POPUP_TOGGLE:
            return Object.assign(Object.assign({}, state), { collapsed: !state.collapsed });
        default:
            return state;
    }
};
